import { ModelNameFlags } from '@era/locations-sdk';
import { AppLockState as LockState } from '@era/settings-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CategoryType } from '../shared/types';

export type AppleBundleIdentifier = string;

export class AppLockBase {
  appLockState?: LockState;
  categoryType?: CategoryType;
  categoryId?: string;
  bundleIdentifier: AppleBundleIdentifier;
}

// the UI uses this one app lock per modelName. The API uses a set of modelNames per app lock (similar to AppLocks below)
export class AppLock extends AppLockBase {
  modelName: ModelNameFlags;
}

// enables reducer to convert these objects into individual app locks for the store
export class AppLocks extends AppLockBase {
  modelNames: ModelNameFlags[];
}

export function selectIdFromAppLock(appLock: AppLock) {
  return selectId(appLock.categoryType, appLock.categoryId, appLock.appLockState, appLock.modelName);
}

export function selectId(
  categoryType: CategoryType,
  categoryId: string,
  appLockState: LockState,
  modelName: ModelNameFlags
) {
  let id = `${categoryType}-${categoryId}`;

  if (appLockState) {
    id += `-${appLockState}`;
  }

  if (modelName) {
    id += `-${modelName}`;
  }

  return id;
}

export const adapter: EntityAdapter<AppLock> = createEntityAdapter<AppLock>({
  selectId: selectIdFromAppLock,
});

export type AppLockState = EntityState<AppLock>;

export const initialState: AppLockState = adapter.getInitialState();
